import React, { useRef, useEffect, useState } from 'react';

const TABS = [
  { key: 'personal', label: 'Personal', icon: '👤' },
  { key: 'payroll', label: 'Salary', icon: '💰' },
  { key: 'documents', label: 'Documents', icon: '📄' },
];

export default function PayrollTabs({ activeTab, onTabChange }) {
  const tabsRef = useRef({});
  const [inkStyle, setInkStyle] = useState({ left: 0, width: 0 });

  useEffect(function () {
    const el = tabsRef.current[activeTab];
    if (el) {
      setInkStyle({
        left: el.offsetLeft,
        width: el.offsetWidth,
      });
    }
  }, [activeTab]);

  return (
    <div className="pr-tabs">
      {TABS.map(function (tab) {
        return (
          <button
            key={tab.key}
            ref={function (el) { tabsRef.current[tab.key] = el; }}
            className={'pr-tab' + (activeTab === tab.key ? ' active' : '')}
            onClick={function () { onTabChange(tab.key); }}
          >
            <span style={{ marginRight: 6, fontSize: '0.9em' }}>{tab.icon}</span>
            {tab.label}
          </button>
        );
      })}
      <span
        className="pr-tab-ink"
        style={inkStyle}
      />
    </div>
  );
}
